import { createElement, useEffect, useMemo, useState } from '@max/max';
import LImage from '@max/leez-image';
import ScrollView from '@hfe/max-scrollview';
import { _remStyle, _toPx } from '../../../utils/style';
import { getImgWidthHeightR } from '../../../utils/getImage';
const ImageTabItem = (props) => {
    const { imgSize, imageStyles, item: { data, isActive, index }, onItemPress } = props;
    const style = _remStyle({
        marginRight: index % 4 ? 18 : 0,
        marginBottom: 18
    });
    return <LImage style={Object.assign(Object.assign({}, style), imageStyles)} {...imgSize} resizeMode="stretch" source={{
            uri: isActive ? data.activeImg : data.defaultImg
        }} onPress={() => {
            onItemPress === null || onItemPress === void 0 ? void 0 : onItemPress(index, data);
        }}/>;
};
const ImageTab = (props) => {
    const { data, imageStyles, onItemPress } = props;
    const [imgSize, setImgSize] = useState({});
    let activeIndex = props.activeIndex;
    if (!activeIndex || activeIndex < 0)
        activeIndex = 0;
    if (activeIndex >= data.length)
        activeIndex = data.length - 1;
    const _data = useMemo(() => data.map((item, index) => (Object.assign(Object.assign({}, item), { styles: {}, data: item, index, key: item.tabKey, isFirst: index === 0, isLast: index === data.length - 1, 
        // hack 这个 isActive 判断不能直接写在 jsx 中，小程序编译失败
        isActive: index === activeIndex }))), [data, activeIndex]);
    useEffect(() => {
        var _a;
        const imageUrl = (_a = _data[0]) === null || _a === void 0 ? void 0 : _a.data.activeImg;
        if (imageUrl) {
            getImgWidthHeightR(imageUrl).then(r => {
                const length = _data.length > 5 ? 5 : _data.length || 0;
                const width = (750 - 18 * (length - 1)) / length;
                const height = width / r;
                const res = height > 140 ? {
                    height: _toPx(140)
                } : {
                    width: _toPx(width)
                };
                setImgSize(res);
            });
        }
    }, []);
    return <ScrollView style={{
            flexDirection: 'column'
        }} contentContainerStyle={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexFlow: 'wrap'
        }} horizontal={true} directionalLockEnabled={true} scrollsToTop={false} showsHorizontalScrollIndicator={false} scrollEventThrottle={40}>
      {_data.map((item) => {
            return <ImageTabItem key={item.key} item={item} onItemPress={onItemPress} imgSize={imgSize} imageStyles={imageStyles}/>;
        })}
    </ScrollView>;
};
export default ImageTab;
